import * as React from 'react'
import type { SVGProps } from 'react'
const SvgTonSymbol = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 6.07 6.07"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.0823 0H0.984791C0.231405 0 -0.24611 0.812678 0.132919 1.46966L2.66175 5.85283C2.82677 6.13903 3.24032 6.13903 3.40534 5.85283L5.93468 1.46966C6.3132 0.813728 5.83568 0 5.08281 0H5.0823ZM2.65969 4.53838L2.10895 3.4725L0.780083 1.09579C0.692419 0.943671 0.800697 0.748736 0.984276 0.748736H2.65918V4.53889L2.65969 4.53838ZM5.28598 1.09528L3.95762 3.47301L3.40688 4.53838V0.748221H5.08178C5.26536 0.748221 5.37364 0.943157 5.28598 1.09528Z"
      fill="currentColor"
    />
  </svg>
)
export default SvgTonSymbol
